<div class="sales-content">
  <!-- Header Section -->
  <div class="sales-header">
    <div class="header-info">
      <h1 class="page-title">Packages</h1>
      <p class="page-description">View and manage car wash packages</p>
    </div>
  </div>

  <!-- Stats Cards Section -->
  <div class="stats-section">
    <div class="stats-grid">
      <app-stats-card
        *ngFor="let stat of salesStats; trackBy: trackByIndex"
        [title]="stat.title"
        [value]="stat.value"
        [icon]="stat.icon"
        [color]="stat.color"
        [valueColor]="stat.valueColor"
      >
      </app-stats-card>
    </div>
  </div>

  <!-- Search and Filter Section -->
  <div class="search-filter-section">
    <!-- Filter button - shown first on mobile -->
    <div class="actions-container mobile-first">
      <app-action-button
        buttonText="Filter"
        iconSrc="assets/images/package/adjustments.svg"
        [showCount]="true"
        [count]="getActiveFilterCount()"
        (buttonClick)="showFilterModal()"
      >
      </app-action-button>
    </div>

    <!-- Search bar -->
    <app-searchbar
      placeholder="Search for packages.."
      [searchTerm]="searchText"
      (searchChange)="onSearchInput($event)"
      customClass="sales-search-bar"
    >
    </app-searchbar>

    <!-- Filter button - shown second on desktop/tablet -->
    <div class="actions-container desktop-first">
      <app-action-button
        buttonText="Filter"
        iconSrc="assets/images/package/adjustments.svg"
        [showCount]="true"
        [count]="getActiveFilterCount()"
        (buttonClick)="showFilterModal()"
      >
      </app-action-button>
    </div>
  </div>

  <!-- Packages Grid Section -->
  <div class="packages-section">
    <app-sales-package-grid
      *ngIf="!loading && filteredPackages.length > 0"
      [packages]="filteredPackages"
      (packageSelected)="onSelectPackage($event)"
    >
    </app-sales-package-grid>

    <!-- Loading State - Shimmer Effect -->
    <div class="loading-state" *ngIf="loading">
      <div class="shimmer-card" *ngFor="let item of [1, 2, 3, 4, 5, 6]; trackBy: trackByIndex">
        <div class="shimmer-content">
          <div class="shimmer-title"></div>
          <div class="shimmer-description"></div>
          <div class="shimmer-description"></div>
          <div class="shimmer-price"></div>
        </div>
      </div>
    </div>

    <!-- Empty State -->
    <div *ngIf="!loading && filteredPackages.length === 0" class="empty-state-container">
      <app-empty-result image="/assets/images/empty_screen.png" title="No packages to show">
      </app-empty-result>
    </div>
  </div>
</div>

<!-- Filter Modal -->
<app-filter-modal
  [isVisible]="isFilterModalVisible"
  [categories]="filterCategories"
  header="Filter Packages"
  primaryButtonText="Apply Filters"
  secondaryButtonText="Clear Filters"
  (close)="closeFilterModal()"
  (apply)="onFiltersApplied($event)"
>
</app-filter-modal>
